import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import managerTestApi from "api/managerTest";
import {ListExam} from "models/managerTest";
import moment from "moment";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {dateTimeToFormatDDMMYYYY, dateTimeToFormatHHMM} from "utils/dateTimeFormat";

export interface RescheduleExamModalProps {
  open: boolean;
  exam: Pick<ListExam, "id" | "examTitle" | "startDate" | "examTime"> | null;
  onClose: () => void;
  onSuccess?: () => void;
}

export default function RescheduleExamModal({
  open,
  exam,
  onClose,
  onSuccess,
}: RescheduleExamModalProps) {
  const {t} = useTranslation();
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open || !exam?.startDate) {
      return;
    }
    setDate(moment(exam.startDate).format("YYYY-MM-DD"));
    setTime(moment(exam.startDate).format("HH:mm"));
  }, [open, exam?.id, exam?.startDate]);

  const handleSubmit = async () => {
    if (!exam?.id || !date || !time) {
      toast.error(t("managerTest.vuilongchonngayvagiothimoi"));
      return;
    }

    const newStart = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm");
    if (!newStart.isValid()) {
      toast.error(t("managerTest.ngaygiohonghople"));
      return;
    }
    if (!newStart.isAfter(moment())) {
      toast.error(t("managerTest.giothimoiphaitrongtgianhientai"));
      return;
    }

    const startDate = `${date}T${time}`;
    const endMoment = newStart.clone().add(Number(exam.examTime) || 0, "minutes");
    const endDate = `${endMoment.format("YYYY-MM-DD")}T${endMoment.format("HH:mm")}`;

    setSubmitting(true);
    try {
      const res = await managerTestApi.updateExamV2({startDate, endDate}, String(exam.id));
      if (res.responseCode === "00") {
        toast.success(t("managerTest.doilichthithanhcong"));
        onSuccess?.();
        onClose();
      } else {
        toast.error(res.responseDescription || t("managerTest.doilichthithatbai"));
      }
    } catch (error: any) {
      toast.error(error?.message || t("managerTest.doilichthithatbai"));
    } finally {
      setSubmitting(false);
    }
  };

  if (!exam) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("managerTest.doilichthi")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{marginBottom: 12}}>
          <strong>{exam.examTitle}</strong>
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{marginBottom: 16}}>
          {t("managerTest.hientai")}: {dateTimeToFormatDDMMYYYY(exam.startDate)} —{" "}
          {dateTimeToFormatHHMM(exam.startDate)}
          {exam.examTime ? ` (${exam.examTime} ${t("community.phut")})` : ""}
        </Typography>
        <Box display="flex" style={{gap: 12}}>
          <TextField
            label={t("managerTest.ngaykiemtra")}
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            InputLabelProps={{shrink: true}}
            inputProps={{min: moment().format("YYYY-MM-DD")}}
            fullWidth
          />
          <TextField
            label={t("managerTest.giothi")}
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            InputLabelProps={{shrink: true}}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          {t("delete.huybo")}
        </Button>
        <Button color="primary" variant="contained" onClick={handleSubmit} disabled={submitting}>
          {submitting ? t("managerTest.dangluu") : t("managerTest.luulichmoi")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
